import React, { FC } from 'react';

import { BootstrapQuery, useBootstrapQuery } from 'api';
import { ErrorPage, Loaders } from 'components';
import { useCognitoUser } from 'hooks';
import { USER_DISABLED } from 'features/auth/constants';

import Providers from './Providers';
import Logout from './Logout';

const ProtectedIndex: FC = ({ children }) => {
  const auth = useCognitoUser();
  const variables = { user_id: auth.id };
  const { data, error, isLoading } = useBootstrapQuery<BootstrapQuery, Error>(variables);

  if (isLoading) {
    return <Loaders.Startup />;
  }

  if (error?.message === USER_DISABLED) {
    return <Logout />;
  }

  if (error) {
    return <ErrorPage />;
  }

  return <Providers bootstrapQuery={data}>{children}</Providers>;
};

export default ProtectedIndex;
